/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./crosstab/SwapRowColumnAction',
	'./crosstab/HideShowSummariesAction'
], (SwapRowColumnAction, HideShowSummariesAction) => {

	class CrosstabActions {
		constructor({ features }) {
			const swapAction = new SwapRowColumnAction(features);
			features.ContentActions.registerProvider('crosstabSwap', swapAction.getAPI());

			const hideShowSummariesAction = new HideShowSummariesAction(features);
			features.ContentActions.registerProvider('crosstabHideShowSummaries', hideShowSummariesAction.getAPI());
		}
	}

	return CrosstabActions;
});
